export default __webpack_public_path__ + "static/media/oscer-pres-jaundice.724ce6c2.svg";